import React, { useState } from 'react'
import { Popover } from '@headlessui/react'
import Link from 'components/Link'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import ApiClient from 'data/api/api_client'
import { CrossIcon, LoadingIcon, NavbarBell } from 'components/icons'
import NotificationDot from 'components/NotificationDot'
import NotificationContent from 'components/notifications/NotificationContent'

const NotificationsPopover = () => {
  const queryClient = useQueryClient()

  const { data: notifications, refetch, isLoading } = useQuery(
    'notifications',
    () => ApiClient.notifications.getNotifications({
      status: 'unread',
    }, {
      paginated: true,
    }),
    {
      keepPreviousData: true,
    },
  )

  const deleteNotificationMutation = useMutation(
    (notification) => ApiClient.notifications.deleteNotification(notification),
    {
      onSuccess: () => {
        refetch()
        queryClient.invalidateQueries(['notifications'])
      },
    },
  )

  const [popoverOpen, setPopoverOpen] = useState(false)

  return (
    <>
      {popoverOpen
        && <div className="fixed inset-0 z-50" onClick={() => setPopoverOpen(false)} />
      }
      <Popover className="relative z-50">
        {() => (
          <>
            <Popover.Button className="focus:outline-none" onClick={() => setPopoverOpen(!popoverOpen)}>
              <div className={`pb-[25px] -mb-[25px] 2xl:-mb-[23px] 2xl:pb-[23px] text-24 transition-all border-b-2  ${popoverOpen ? ' border-primary-fresh' : 'border-transparent'}`} >
                <NavbarBell className="text-grey-700" />
                {notifications?.meta.total > 0 ? <NotificationDot number={notifications?.meta.total} /> : null}
              </div>
            </Popover.Button>

            {popoverOpen
              && <Popover.Panel static
                className="absolute right-0 top-[57px] 2xl:top-[59px] h-[400px] w-[360px] bg-primary-light"
              >
                <div className="flex flex-col items-center justify-start h-full py-20 bg-white shadow-public-searchbar rounded-4">
                  <div className="mb-10 font-bold text-center text-grey-800 text-16 leading-24">
                    Notifications
                  </div>
                  {isLoading
                    ? <LoadingIcon />
                    :                    notifications?.notifications?.length
                      ? <div className="flex flex-col w-full gap-20 px-20 overflow-y-auto text-14">
                        {
                          notifications?.notifications.map((notification, index) => (
                            <div key={index} className="flex flex-col min-h-[50px] pt-20 gap-20">
                              <div className="flex items-center justify-between h-full gap-10">
                                <div className="w-full text-left text-grey-750 md:text-grey-800">
                                  <NotificationContent notification={notification} />
                                </div>
                                <button
                                  className="self-start cursor-pointer text-grey-500 text-20"
                                  onClick={() => deleteNotificationMutation.mutate(notification)}
                                >
                                  <CrossIcon />
                                </button>
                              </div>
                              <hr className="text-grey-200" />
                            </div>
                          ))
                        }
                      </div>
                      :                      <div className={'flex flex-col gap-20 transition-all items-center justify-evenly w-full h-full'}>
                        <p className="font-bold text-grey-800 text-14">
                          No new notifications
                        </p>
                      </div>
                  }

                  <Link
                    href="/home/notifications"
                    className={` text-primary leading-[20px] text-14 font-bold underline mt-5 ${notifications?.notifications?.length ? 'text-opacity-100' : 'text-opacity-50'}`}
                  >
                    View all
                  </Link>
                </div>
              </Popover.Panel>
            }
          </>
        )}
      </Popover>
    </>
  )
}

export default NotificationsPopover
